import { render, staticRenderFns } from "./safety.vue?vue&type=template&id=b9822f6e&"
import script from "./safety.vue?vue&type=script&lang=js&"
export * from "./safety.vue?vue&type=script&lang=js&"
import style0 from "./safety.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports